const AppLoader = () => {
    return (
        <>
            <div className="text-center app-loader spinner-block d-flex align-items-center justify-content-center">
                <div className="spinner spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </>
    );
};

export default AppLoader;
